module.exports = __webpack_public_path__ + "static/img/our-awards_9.d6682ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_9.png
// module id = YsNp
// module chunks = 0